import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getSeoSetting, saveSeoSetting } from '../../../redux/actions/siteActions';

let isLoading = "false";
class SeoSetting extends Component {
  constructor(props){
    super(props);
    this.state = {
      path: ['Home', 'SEO Setting'], 
      links: ["home",'/seo-settings'],
      site_title: "",
      meta_keywords: "",
      meta_description: "",
      analytics_tracking_code_head: "",
      analytics_tracking_code_body: "",
      show: false,
      alertMessage: '',
      msgType: '',
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleDismiss(){
  	this.setState({
  		show: false,
  		alertMessage: '',
  		msgType: '',
  	});
  }

  componentWillMount(){
    this.handPageChange();
  }

  handPageChange(){
  	isLoading = "true";
  	this.props.getSeoSetting();
  }
  componentWillReceiveProps(nextProps){
  	if(this.props.apiDetail !== nextProps.apiDetail){
  		if(nextProps.apiDetail){
			if(nextProps.apiDetail.data){
				this.setState({
          site_title: nextProps.apiDetail.data.site_title,
          meta_keywords: nextProps.apiDetail.data.meta_keywords,
          meta_description: nextProps.apiDetail.data.meta_description,
          analytics_tracking_code_head: nextProps.apiDetail.data.analytics_tracking_code_head,
          analytics_tracking_code_body: nextProps.apiDetail.data.analytics_tracking_code_body,
          tag_manager_tracking_code_body: nextProps.apiDetail.data.tag_manager_tracking_code_body,
				});
			}
			isLoading = "false";
		}
  	}

  	if(this.props.settingStatus !== nextProps.settingStatus){
  		if(nextProps.settingStatus){
			this.setState({
		  		show: true,
		  		alertMessage: nextProps.settingStatus.message,
		  		msgType: 'success',
		  	});

			this.handPageChange();
		}
  	}

  	if(this.props.error !== nextProps.error){
  		if(nextProps.error){
			this.setState({
		  		show: true,
		  		alertMessage: nextProps.error.message,
		  		msgType: 'danger',
		  	});

			this.handPageChange();
		}
  	}
  }

  handleChange = (e) => {
  	if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
  	this.setState({[e.target.name] : e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const constData = {
      site_title: (this.state.site_title) ? this.state.site_title : "",
      meta_keywords: (this.state.meta_keywords) ? this.state.meta_keywords : "",
      meta_description: (this.state.meta_description) ? this.state.meta_description : "",
      analytics_tracking_code_head: (this.state.analytics_tracking_code_head) ? this.state.analytics_tracking_code_head : "",
      analytics_tracking_code_body: (this.state.analytics_tracking_code_body) ? this.state.analytics_tracking_code_body : "",
      tag_manager_tracking_code_body: (this.state.tag_manager_tracking_code_body) ? this.state.tag_manager_tracking_code_body : "",
    }
    isLoading = "true";
    this.props.saveSeoSetting(constData);
  }

  render() {
    
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">SEO Setting</header>
          <div className="panel-body">
          {this.state.show && this.state.alertMessage !=='' &&  
          	<Row>      
              <Col md={12} xs={12}>
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </Col>
            </Row>
          }
          <Row>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>Site Title:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="Site Title"
		              value={this.state.site_title}
		              name="site_title"
		              onChange={this.handleChange}
		            />
	            </FormGroup>
	          </Col>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>Meta Keywords:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="Meta Keywords"
		              value={this.state.meta_keywords}
		              name="meta_keywords"
		              onChange={this.handleChange}
		            />
	            </FormGroup>
	          </Col>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>Meta Description:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="Meta Description"
		              value={this.state.meta_description}
		              name="meta_description"
		              onChange={this.handleChange}
		            />
	            </FormGroup>
	          </Col>
	          <Col md={6} xs={6}>
              <FormGroup>
                <ControlLabel>Analytics Tracking Code (In &lt; head &gt; tag):</ControlLabel>
              <FormControl
                        value={
                          this.state.analytics_tracking_code_head
                            ? this.state.analytics_tracking_code_head
                            : ""
                        }
                        componentClass="textarea"
                        onChange={this.handleChange}
                        name="analytics_tracking_code_head"
                        placeholder="Analytics Tracking Code"
                      />
              </FormGroup>
            </Col>
            <Col md={6} xs={6}>
              <FormGroup>
                <ControlLabel>Analytics Tracking Code (In &lt; body &gt; tag):</ControlLabel>
                <FormControl
                        value={
                          this.state.analytics_tracking_code_body
                            ? this.state.analytics_tracking_code_body
                            : ""
                        }
                        componentClass="textarea"
                        onChange={this.handleChange}
                        name="analytics_tracking_code_body"
                        placeholder="Analytics Tracking Code"
                />
              </FormGroup>
            </Col>
            <Col md={6} xs={6}>
              <FormGroup>
                <ControlLabel>Google Tag Manager Code (for ex - GTM-VM12EL3):</ControlLabel>
              <FormControl
                        value={
                          this.state.tag_manager_tracking_code_body
                            ? this.state.tag_manager_tracking_code_body
                            : ""
                        }
                        componentClass="textarea"
                        onChange={this.handleChange}
                        name="tag_manager_tracking_code_body"
                        placeholder="Analytics Tracking Code"
                />
              </FormGroup>
            </Col>
          </Row>
          
          <Row><hr/></Row>
          <Row>
            <Col md={12} xs={12}>
              <Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Save</Button>
            </Col>
          </Row>
          </div>
      </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.siteReducer.error,
      apiDetail:  state.siteReducer.apiDetail,
      settingStatus:  state.siteReducer.settingStatus,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getSeoSetting, saveSeoSetting})
)(SeoSetting);



// WEBPACK FOOTER //
// ./src/app/views/admin/setting/SeoSetting.js